export default Object.freeze([
    // Lazarus
    {
      path: '/event/damian-lazarus-mia-tulum-november-2023',
      name: 'lazaruz-bonbo',
      redirect: () => {
        return '/event/damian-lazarus-bonbonniere-tulum-january-2024';
      }
    },

  // Removed old redirects. May/07
  ]
)


